import { userApi } from '@/api/services/userApi';
import { TextBox } from '@/components/ui';
import { createChinaAppSysUser, type ChinaAppSysUser } from '@/types/entities';

import { AdminNotice } from '../AdminNotice';
import { AdminUserGroupsList } from '../lists/AdminUserGroupsList';
import { AdminFormFrame } from './AdminFormFrame';
import { useAdminForm } from './useAdminForm';

/** Port von `IwmAdminBenutzerForm.razor` in der Gestalt aus REQ-25 §4.6 (REQ-28 §2). */
export interface AdminUserFormProps {
  /** `0` legt einen neuen Benutzer an. */
  id: number;
  onSave: (id: number) => void | Promise<void>;
}

const fetch = (id: number) => userApi.getEntry(id);
const create = (model: ChinaAppSysUser) => userApi.create(model);
const put = (id: number, model: ChinaAppSysUser) => userApi.put(id, model);
const remove = (id: number) => userApi.remove(id);

export function AdminUserForm(props: AdminUserFormProps) {
  const form = useAdminForm({
    id: props.id,
    createEmpty: createChinaAppSysUser,
    fetch,
    create,
    put,
    remove,
    deleteMessage:
      'Möchten Sie diesen Benutzer wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteTitle: 'Benutzer löschen',
    onSave: props.onSave,
  });
  const { model } = form;
  const existing = model.Id > 0;

  return (
    <AdminFormFrame
      title={existing ? (model.Name ?? '') || (model.EMail ?? '') : undefined}
      showDelete={existing}
      saving={form.saving}
      isValid={form.isValid}
      dirty={form.dirty}
      onNew={form.onNew}
      onRefresh={() => form.reload()}
      onDelete={form.onDelete}
      onSave={form.onSave}
    >
      <div className="iwm-admin-form-grid">
        <TextBox
          value={model.Name}
          onChange={(value) => {
            form.setField('Name', value);
          }}
          label="Name"
        />
        <TextBox
          value={model.EMail}
          onChange={(value) => {
            form.setField('EMail', value);
          }}
          label="E-Mail"
          readOnly={existing}
        />
        {existing ? (
          <TextBox
            value={model.Oid}
            onChange={(value) => {
              form.setField('Oid', value);
            }}
            label="Oid"
            readOnly
          />
        ) : null}
      </div>
      {existing ? (
        <AdminUserGroupsList parentId={model.Id} />
      ) : (
        <AdminNotice>
          Gruppen lassen sich erst zuordnen, wenn der Benutzer gespeichert ist.
        </AdminNotice>
      )}
    </AdminFormFrame>
  );
}

export default AdminUserForm;
